import { render, staticRenderFns } from "./KnowledgeOptionsStep.vue?vue&type=template&id=0b33e5cd&"
import script from "./KnowledgeOptionsStep.vue?vue&type=script&lang=js&"
export * from "./KnowledgeOptionsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b33e5cd')) {
      api.createRecord('0b33e5cd', component.options)
    } else {
      api.reload('0b33e5cd', component.options)
    }
    module.hot.accept("./KnowledgeOptionsStep.vue?vue&type=template&id=0b33e5cd&", function () {
      api.rerender('0b33e5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/KnowledgeOptionsStep.vue"
export default component.exports